import styled, { css } from 'styled-components';

export const Container = styled.header`
  ${({ theme }) => css`
    display: flex;
    padding: ${theme.layout.spacing(3)};
    gap: ${theme.layout.spacing(2)};
    align-items: flex-start;

    &[data-center='true'] {
      align-items: center;
    }

    > div {
      display: flex;
      flex-direction: column;
      gap: ${theme.layout.spacing(2)};
      flex: 1;

      h2 {
        font-size: ${theme.typography.sizes.title2};
        font-weight: ${theme.typography.weight.extraBold};
      }

      h4 {
        font-size: ${theme.typography.sizes.subtitle};
        font-weight: ${theme.typography.weight.bold};
        color: ${theme.palette.text.light};
      }
    }

    > button {
      display: flex;
      padding: ${theme.layout.spacing(1.25)};
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 0.5rem;
      background: ${theme.palette.neutral[200]};
      color: ${theme.palette.neutral[600]};
      font-size: 1rem;
      border: none;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background: ${theme.palette.neutral[300]};
      }
    }
  `}
`;
